import { Controller } from "@hotwired/stimulus";

// Smooth accordion: animates each panel's height via grid-template-rows (0fr ↔ 1fr).
// One panel open at a time; click an open one to close it.
export default class extends Controller {
  static targets = ["trigger", "panel"];

  toggle(event) {
    const clicked = this.triggerTargets.indexOf(event.currentTarget);
    const willOpen = event.currentTarget.getAttribute("aria-expanded") !== "true";

    this.triggerTargets.forEach((trigger, i) => {
      const open = i === clicked && willOpen;
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
      this.panelTargets[i].style.gridTemplateRows = open ? "1fr" : "0fr";
    });
  }
}
